import type { UpdateMyInfoRequest } from "src/shared/api-types/user";

import { removeDuplicates, Person, PersonResponse } from "./base";
import { CrewWithPermissions } from "./crew";
import request from "./request";

export enum PersonRole {
  TRAINER = "trainer",
  INSTRUCTOR = "instructor",
  ASSESSOR = "assessor",
  CHECKER = "checker",
}

export interface PersonWithRoleResponse extends PersonResponse {
  roleCode: string;
  roleID: number;
}

export interface MyInfoResponse {
  birthday: string;
  city: string;
  country: string;
  crews: CrewWithPermissions[];
  email: string;
  fcl: string | null;
  fullname: string;
  id: number;
  language: string;
  payWithInvoice: number;
  profileimageurl: string;
  sa: boolean;
  ta: boolean;
  username: string;
}

export class PersonWithRole extends Person {
  public roleCode: PersonRole;
  public roleID: number;

  constructor(data: PersonWithRoleResponse) {
    super(data);
    this.roleCode = data.roleCode as PersonRole;
    this.roleID = data.roleID;
  }
}

export const getMyInfo = async (): Promise<MyInfoResponse> => {
  const json = await request(`/user/me`);
  return json;
};

// TODO: CREW-356 - review this endpoint
export const updateMyInfo = async (data: UpdateMyInfoRequest): Promise<any> => {
  const json = await request.put(`/user/me`, data);
  return json;
};

export const getAllEvaluators = async (): Promise<PersonWithRole[]> => {
  const response = await request(`/user/trainers/`);
  return response.map((data: PersonWithRoleResponse) => new PersonWithRole(data));
};

export const filterPersonsByRole = (persons: PersonWithRole[], role: PersonRole): PersonWithRole[] => {
  return removeDuplicates(persons.filter((person) => person.roleCode === role));
};
